// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nbody:has(.auth-page),\nbody:has(.auth-page) #app {\n\tbackground-color: var(--castr-bg);\n}\nbody:has(.auth-page) .footer span {\n\tcolor: var(--castr-text-muted);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
